import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Form, Input } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import { fieldTypeName } from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import { updateActiveLookupType } from '../../dictionaries/actions';
import LookupTypeDropdown from '../components/LookupTypeDropdown';
import { canEditDataset } from '../../helper';

const DictionaryLookupSettings = ({
  lookupType,
  updateLookupType,
  canEdit,
  pmnFunctions,
}) => {
  const intl = useIntl();
  const handleChange = (value) => updateLookupType(value, pmnFunctions);

  return (
    <Form autoComplete="off">
      <FormValidationError
        htmlFor="lookup_type_dropdown"
        labelId="lookup.field.type"
      >
        {canEdit && (
        <LookupTypeDropdown lookupType={lookupType} onChange={handleChange} />
        )}
        {!canEdit && (
        <Input
          id="lookup_type_dropdown"
          disabled
          type="custom"
          size="large"
          value={intl.formatMessage({ id: fieldTypeName(lookupType) })}
        />
        )}
      </FormValidationError>
    </Form>
  );
};

const mapStateToProps = ({
  datasets: {
    lookups,
  },
  auth: {
    role,
  },
  pmnFunctions: {
    pmnFunctions,
  },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const items = dictionary ? dictionary.lookups || {} : {};

  return (
    {
      canEdit: canEditDataset(lookups, role),
      lookupType: items[lookups.activeLookupName] ? items[lookups.activeLookupName].type : 'text',
      pmnFunctions: pmnFunctions?.lookups?.results || [],
    }
  );
};

const mapDispatchToProps = {
  updateLookupType: updateActiveLookupType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryLookupSettings);
